export default __webpack_public_path__ + "static/media/heart.cdc59a6d.svg";